<div data-test="Ifz6KvI5" class="modal modal_fullscreen" [class.active]="active">
  <div data-test="KNoNfTLL" class="modal__wrap" data-simplebar="init">
    <div
      data-test="3UHEekVg"
      class="simplebar-scroll-content"
      style="padding-right: 20px; margin-bottom: -20px"
    >
      <div data-test="9yNJ4zQP" class="simplebar-content" style="padding-bottom: 20px">
        <div data-test="Rgc4Up9e" class="modal__window">
          <button
            data-test="t9zXzG27"
            class="modal__close"
            type="button"
            (click)="hideCompanySwitcher()"
          >
            <span data-test="u99O4C7k" class="badge badge_gray">
              <i data-test="fRH9MLu4" class="material-icons md-12">close</i>
            </span>
          </button>
          <div data-test="f_UX7ztM" class="container-fluid">
            <div data-test="mmmiDvls" class="modal__header">
              <h2 data-test="b-O9cEyY" class="modal__title">Choose a brand</h2>
              <div data-test="zqFXftGL" class="modal__search">
                <form data-test="YZXqmEL3" class="search">
                  <input
                    data-test="0Y_I9y9B"
                    class="input input_bb text-center"
                    id="search-2"
                    type="search"
                    placeholder="Search for brands..."
                    [(ngModel)]="filterQuery"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </form>
              </div>
            </div>
            <div data-test="kWcv86X6" class="brands">
              <div data-test="p_nnQ689" class="brands__wrap">
                <div
                  data-test="h8zy_tLe"
                  class="brands__item"
                  *ngFor="let company of filteredCompanies"
                  (click)="selectCompany(company.uuid)"
                >
                  <a
                    data-test="Pi8UCnMz"
                    class="brand"
                    [class.active]="company.uuid === currentCompanyId"
                  >
                    <div data-test="oKgr6tgY" class="brand__logo">
                      <md-letter-image
                        data-test="SY0Tnhbe"
                        [size]="96"
                        class="brand__logo-img"
                        [image]="company.logo"
                        [name]="company.name"
                      ></md-letter-image>
                      <div data-test="QaqRaPgP"></div>
                    </div>
                    <div data-test="ltgYgZTH" class="brand__name">{{ company.name }}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
